import { Intersect } from '@/directives/intersect'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('intersect', Intersect)
  // if (import.meta.client) {
  //   const { default: Vue3Lottie } = await import('vue3-lottie')
  //   nuxtApp.vueApp.component('Vue3Lottie', Vue3Lottie)
  // }
})
